// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Text,
  TextLink,
  Paragraph,
  ScreenReaderOnly
} from 'seek-style-guide/react';

import { sendFraudReport } from 'src/store/jobdetails/jobdetails';
import ReportJobForm from './ReportJobForm/ReportJobForm';
import FormContainer from 'src/components/FormContainer/FormContainer';

const mapStateToProps = ({ user, jobdetails }) => ({
  jobId: jobdetails.result.id,
  emailAddress: user.emailAddress
});

const mapDispatchToProps = {
  onSubmitFraudReport: sendFraudReport
};

type Props = {
  jobId: number,
  emailAddress?: string,
  onSubmitFraudReport: Function
};

type State = {
  formVisible?: boolean,
  submitted?: boolean,
  submissionFailed?: boolean
};

class ReportThisAd extends Component<Props, State> {
  constructor(props: Props): void {
    super(props);
    this.state = {
      formVisible: false,
      submitted: false,
      submissionFailed: false
    };
  }

  visibilityToggleClicked = (e: MouseEvent): void => {
    e.preventDefault();

    this.setState({
      formVisible: !this.state.formVisible
    });
  };

  submitReport = (formValues: FraudReport): void => {
    this.props
      .onSubmitFraudReport(formValues)
      .then(() => {
        this.setState({
          submitted: true,
          submissionFailed: false
        });
      })
      .catch(() => {
        this.setState({
          submitted: false,
          submissionFailed: true
        });
      });
  };

  cancelReport = (e: MouseEvent): void => {
    e.preventDefault();

    this.setState({
      formVisible: false
    });
  };

  renderForm() {
    const { emailAddress, jobId } = this.props;
    const { submitted, submissionFailed } = this.state;
    return (
      <FormContainer
        showSuccess={submitted}
        successRenderer="Thank you. Your job report has been forwarded to our job quality team."
        showError={submissionFailed}
        errorRenderer="It looks like something went wrong and your report could not be sent."
      >
        <ReportJobForm
          jobId={jobId}
          email={emailAddress}
          submit={this.submitReport}
          cancel={this.cancelReport}
        />
      </FormContainer>
    );
  }

  renderToggle() {
    return (
      <span>
        {'If you see something suspicious '}
        <TextLink
          href="#"
          aria-expanded={this.state.formVisible}
          data-automation="report-job-ad-toggle"
          onClick={this.visibilityToggleClicked}
          rel="nofollow"
        >
          report this job ad
        </TextLink>
        .
      </span>
    );
  }

  render() {
    const { formVisible, submitted } = this.state;
    return (
      <div>
        <ScreenReaderOnly>
          <h2>Report this job advert</h2>
        </ScreenReaderOnly>
        <Paragraph>
          <Text small raw>
            <TextLink href="/safe-job-searching" rel="nofollow">
              Be careful
            </TextLink>
            {
              '- Don’t provide your bank or credit card details when applying for jobs. '
            }
            {!submitted ? this.renderToggle() : null}
          </Text>
        </Paragraph>

        {formVisible ? this.renderForm() : null}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportThisAd);
